import React from 'react';

export const LoadingState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-4 w-full">
      <svg 
        className="animate-spin h-7 w-7 text-cat-amber" // משתמשים בטוקן הכתום הרשמי שלכם
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-20 text-gray-300 dark:text-cat-border" // הרקע של העיגול מותאם למצב בהיר/כהה שלכם
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="3"
        />
        <path 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {/* צבע הטקסט והפונט שואבים ישירות מהגדרות המערכת הגנריות */}
      <span className="text-[13px] text-gray-500 dark:text-cat-text-muted font-sans tracking-wide">
        Loading events…
      </span>
    </div>
  );
};